

























import { Component, Vue } from "vue-property-decorator";
import i18n from "@/i18n";
import GrabRender from "@/components/posts/grab/GrabRender.vue";
import PreviewModalHeader from "@/components/common/preview/PreviewModalHeader.vue";

@Component({
    components: {
        GrabRender,
        PreviewModalHeader
    }
})
export default class GrabItemPreviewModal extends Vue {
    // local
    grabItem = { } as any;
    scale = 1
    fitScale = 0;
    bgColor = "#ffffff";
    name = "";

    open(item: any) {
        this.name = item.properties.url;
        this.grabItem = item;
        this.setScale();
        this.$bvModal.show("modal-grabItemPreview");
    }

    hide() {
        this.grabItem = {} as any;
        this.$bvModal.hide("modal-grabItemPreview");
    }

    setScale() {
        var scaleX = (window.innerWidth / 100 * 82) / this.model.properties.width;
        var scaleY = (window.innerHeight / 100 * 74) / this.model.properties.height;
        this.scale = scaleX <= scaleY ? scaleX : scaleY;
        this.scale = this.scale >= 1 ? 1 : this.scale;
        this.scale = Math.round(this.scale * 100) / 100;
        this.fitScale = this.scale;
    }

    onScale(value: number) {
        this.scale = value;
    }

    changeBg(color: string) {
        this.bgColor = color;
    }

    scaleUp() {
        this.scale += 0.1;
    }

    scaleDown() {
        if (this.scale - 0.1 >= 0) {
            this.scale -= 0.1;
        }
    }

    get model() {
        return this.grabItem;
    }

    get adaptedSize() {
        return {
            transform: "scale(" + this.scale + ")",
            "transform-origin": "left top",
            height: `${this.model.properties.height}px`,
            width: `${this.model.properties.width}px`
        };
    }
}
